// @flow
/* globals document, window */
import React, { Component, Fragment } from "react";
import { stringify } from "querystring";
import omit from "lodash/omit";
import axios from "axios";

import AgentGrid from "./AgentGrid";
import GlobalAlert from "../common/GlobalAlert";
import { GlobalProvider } from "../common/GlobalContext";

import type {
  $Alerts,
  $Agents,
  $History,
  $Pagination,
  ComplianceItems,
} from "flow/types";

type Props = {
  alerts: $Alerts,
  agents: $Agents,
  pagination: $Pagination,
  path: string,
  history: $History,
  location: Object,
  globalGA: string,
  compliance: ComplianceItems,
  theme: Object, // theme from the API/site settings, not the react-jss theme
};

type State = {
  agents: $Agents,
  pagination: $Pagination,
  isSearching: boolean,
};

class Roster extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      agents: props.agents,
      pagination: props.pagination,
      isSearching: false,
    };
  }

  componentDidUpdate(prevProps: Object) {
    if (prevProps.location.search !== this.props.location.search) {
      this.setState({ isSearching: true });

      let url = `${this.props.path}${this.props.location.search}`;
      if (!url.includes("format=json")) {
        url += `${this.props.location.search ? "&" : "?"}format=json`;
      }

      return axios
        .get(url)
        .then(({ data: { agents, pagination } }) => {
          this.setState({
            agents,
            isSearching: false,
            pagination,
          });
        })
        .catch(() => {
          this.setState({ isSearching: false });
        });
    }
  }

  trackPageView() {
    if (window.ga && typeof window.ga === "function") {
      window.ga("set", "page", this.props.path);
      window.ga("send", "pageview");
    }

    if (
      this.props.globalGA &&
      window.gtag &&
      typeof window.gtag === "function"
    ) {
      window.gtag("config", this.props.globalGA, {
        page_path: this.props.path,
      });
    }
  }

  handleSearch = (e: null | Event, values: Object) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    this.props.history.push(
      `${this.props.path}?${stringify(omit(values, "format"))}`
    );
    this.trackPageView();
  };

  render() {
    const { theme, alerts, path, location, compliance } = this.props;
    const { agents, pagination } = this.state;
    return (
      <GlobalProvider theme={theme} compliance={compliance}>
        <Fragment>
          <GlobalAlert alerts={alerts} />
          <AgentGrid
            path={path}
            agents={agents}
            location={location}
            pagination={pagination}
            handleSearch={(e, values) => this.handleSearch(e, values)}
          />
        </Fragment>
      </GlobalProvider>
    );
  }
}

export default Roster;
